import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import WorkHistoryRoundedIcon from "@mui/icons-material/WorkHistoryRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import FilePresentRoundedIcon from "@mui/icons-material/FilePresentRounded";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RESUME_TOGGLE_DIALOG } from "utils/redux/action";

export default function SideBar({ open, handleClose }) {
  const dispatcher = useDispatch();
  const navigate = useNavigate();
  const navigation = useSelector((state) => state.navigationReducer);

  return (
    <Drawer anchor={"right"} open={open} onClose={handleClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <List sx={{ flex: 1, paddingTop: 2 }}>
          {[
            { title: "Home", icon: HomeRoundedIcon, route: "/" },
            {
              title: "Pendidikan",
              icon: SchoolRoundedIcon,
              route: "/pendidikan",
            },
            {
              title: "Pengalaman",
              icon: WorkHistoryRoundedIcon,
              route: "/pengalaman",
            },
            { title: "Projek", icon: DashboardRoundedIcon, route: "/projek" },
          ].map((nav, index) => (
            <ListItem
              key={index}
              disablePadding
              sx={{
                paddingLeft: 2,
                paddingRight: 5,
                backgroundColor: navigation.index === index ? "rgba(0,0,0,0.1)" : "white",
              }}
            >
              <ListItemButton
                onClick={() => {
                  handleClose();
                  navigate(nav.route);
                }}
              >
                <ListItemIcon>
                  <nav.icon />
                </ListItemIcon>
                <ListItemText
                  primary={nav.title}
                  primaryTypographyProps={{
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: 16,
                    color: "black",
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <List>
          <ListItem disablePadding sx={{ paddingLeft: 2, paddingRight: 5 }}>
            <ListItemButton
              onClick={() => {
                handleClose();
                dispatcher({ type: RESUME_TOGGLE_DIALOG });
              }}
            >
              <ListItemIcon>
                <FilePresentRoundedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Unduh CV"
                primaryTypographyProps={{
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: 16,
                  color: "black",
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
}
